// XSS-safe DOM helpers. Rule (Codex 4.D plan review): innerHTML allowed
// ONLY for static markup / icons (constants imported from src/ui/icons.ts).
// Any data from the URL or API (filename, clientName, reason, modelId, ...)
// MUST be inserted via setText / safe attribute APIs.

export function setText(el: HTMLElement, value: string | number | null | undefined): void {
  el.textContent = value === null || value === undefined ? '' : String(value);
}

const ALLOWED_PROTOCOLS = new Set(['https:', 'mailto:']);

// safeLink resolves the href against window.location.origin so that relative
// paths (e.g. '/upload') are accepted as same-origin links. Cross-origin URLs
// are accepted only on the protocol allowlist (https / mailto).
export function safeLink(href: string, label: string): HTMLAnchorElement {
  const a = document.createElement('a');
  a.classList.add('viewer-ui-interactive');
  try {
    const base =
      typeof window !== 'undefined' && window.location
        ? window.location.origin
        : 'http://localhost';
    const url = new URL(href, base);
    const sameOrigin = url.origin === base;
    if (sameOrigin || ALLOWED_PROTOCOLS.has(url.protocol)) {
      a.href = url.toString();
    } else {
      a.href = '#';
      console.warn('[ui] unsafe link href blocked:', href);
    }
  } catch {
    a.href = '#';
  }
  a.textContent = label;
  return a;
}

export function interactiveButton(label: string, onClick: () => void): HTMLButtonElement {
  const b = document.createElement('button');
  b.type = 'button';
  b.classList.add('viewer-ui-interactive');
  b.textContent = label;
  b.addEventListener('click', onClick);
  return b;
}

export function setHtmlIcon(el: HTMLElement, iconSvg: string): void {
  // Caller responsibility: iconSvg MUST be a static constant from src/ui/icons.ts.
  // Never pass user data here.
  el.innerHTML = iconSvg;
}
